import { OfferData } from 'constants/apiResponses.types';
import { Observable } from './observable';
import { getUtmParams } from '../utils';
import { ELocalStorageKeys } from '../constants/enums';
import { webStorageUtil } from './webStorage.state.service';

interface InstallPromptEvent extends Event {
  prompt: () => Promise<void>;
}

class AppStateService {
  readonly appFullyLoaded = new Observable<boolean>(false);
  readonly displayLoader = new Observable<boolean>(true);
  readonly isReconnecting = new Observable<boolean>(false);
  readonly showConfetti = new Observable<boolean>(false);
  readonly isProfileEnabled = new Observable<boolean>(false);
  readonly failedHashValidation = new Observable<boolean>(false);
  readonly selectedOffer = new Observable<OfferData | null | string>();
  readonly isIntegrationProfilesEnabled = new Observable<boolean>(
    webStorageUtil.get(ELocalStorageKeys.INTEGRATION_PORFILE) !== null
  );
  readonly backgroundProps = new Observable<object>({});
  readonly collectedProductsImages = new Observable<string[]>([]);
  readonly collectedPointsImages = new Observable<string[]>([]);
  readonly infoModalUrl = new Observable<string | null>();
  readonly utms = new Observable<Record<string, string>>(getUtmParams());
  readonly isTabFooterDisplayed = new Observable<boolean>(false);
  readonly installPrompt = new Observable<InstallPromptEvent | null>(null);

  clear = () => {
    this.appFullyLoaded.set(false);
    this.displayLoader.set(false);
    this.isReconnecting.set(false);
    this.failedHashValidation.set(false);
    this.showConfetti.set(false);
    this.isProfileEnabled.set(false);
    this.selectedOffer.set(null);
    this.backgroundProps.set({});
    this.collectedProductsImages.set([]);
    this.collectedPointsImages.set([]);
    this.infoModalUrl.set(null);
    this.utms.set({});
    this.isTabFooterDisplayed.set(false);
    this.installPrompt.set(null);
  };

  setDisplayLoader = (showLoader: boolean) => this.displayLoader.set(showLoader);
  setIsReconnecting = (isReconnecting: boolean) => this.isReconnecting.set(isReconnecting);
  setShowConfetti = (show: boolean) => this.showConfetti.set(show);
  setIsProfileEnabled = (isEnabled: boolean) => this.isProfileEnabled.set(isEnabled);
  setSelectedOffer = (offer: OfferData | null | string) => this.selectedOffer.set(offer);
  setFailedHashValidation = (failed: boolean) => this.failedHashValidation.set(failed);
  setIsIntegrationProfilesEnabled = (showIntegrationProfiles: boolean) =>
    this.isIntegrationProfilesEnabled.set(showIntegrationProfiles);
  setBackgroundProps = (background: object) => this.backgroundProps.set(background);
  setCollectedProductsImages = (images: string[]) => this.collectedProductsImages.set(images);
  setCollectedPointsImages = (images: string[]) => this.collectedPointsImages.set(images);
  setInfoModalUrl = (url?: string) => this.infoModalUrl.set(url || null);
  setUtms = (utm?: Record<string, string>) => this.utms.set(utm || {});
  setIsTabFooterDisplayed = (isDisplayed: boolean) => this.isTabFooterDisplayed.set(isDisplayed);
  setAppFullyLoaded = (isLoaded: boolean) => this.appFullyLoaded.set(isLoaded);
  setInstallPrompt = (installPrompt: InstallPromptEvent | null) =>
    this.installPrompt.set(installPrompt);
}

export const appStateService = new AppStateService();
